// Sound effects for the trading cards, made with the Web Audio API so there are no audio files to load.

const VOLUME = 0.25;

let context = null;

// Browsers only allow sound after a click, so the audio context is made the first time a sound is played
function audio() {
    let AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) {
        return null;
    }
    if (!context) {
        context = new AudioContext();
    }
    if (context.state === 'suspended') {
        context.resume();
    }
    return context;
}

// One note: fades in quickly and rings out over `length` seconds
function tone(ctx, type, frequency, start, length, peak) {
    let osc = ctx.createOscillator();
    let gain = ctx.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(frequency, start);
    gain.gain.setValueAtTime(0.0001, start);
    gain.gain.exponentialRampToValueAtTime(peak * VOLUME, start + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, start + length);
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start(start);
    osc.stop(start + length + 0.05);
    return osc;
}

// Tearing open the wrapper: a burst of hiss that sweeps upward, with a low thump underneath
export function playPackOpen() {
    let ctx = audio();
    if (!ctx) {
        return;
    }
    let now = ctx.currentTime;
    let length = 0.45;

    let buffer = ctx.createBuffer(1, Math.floor(ctx.sampleRate * length), ctx.sampleRate);
    let data = buffer.getChannelData(0);
    for (let i = 0; i < data.length; i++) {
        data[i] = Math.random() * 2 - 1;
    }
    let noise = ctx.createBufferSource();
    noise.buffer = buffer;
    let filter = ctx.createBiquadFilter();
    filter.type = 'bandpass';
    filter.Q.value = 1.2;
    filter.frequency.setValueAtTime(500, now);
    filter.frequency.exponentialRampToValueAtTime(6000, now + length);
    let gain = ctx.createGain();
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(0.9 * VOLUME, now + 0.05);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + length);
    noise.connect(filter);
    filter.connect(gain);
    gain.connect(ctx.destination);
    noise.start(now);

    let thump = tone(ctx, 'sine', 160, now, 0.25, 0.9);
    thump.frequency.exponentialRampToValueAtTime(50, now + 0.25);
}

// A Legendary or Trimmed card turning over: a bright rising chime
export function playSpecialReveal() {
    let ctx = audio();
    if (!ctx) {
        return;
    }
    let now = ctx.currentTime;
    // C6, E6, G6, C7
    [1046.5, 1318.5, 1568, 2093].forEach((frequency, i) => {
        let start = now + i * 0.08;
        tone(ctx, 'triangle', frequency, start, 0.9, 0.5);
        tone(ctx, 'sine', frequency * 2, start, 0.5, 0.15);
    });
}
